import styled from 'styled-components'

export const ModalShell = styled.div`
  position: absolute;
  width: min(960px, 94vw);
  max-height: 90vh;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 12px;
  z-index: 1;
  padding: 20px 20px 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
`

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: 12px;
`

export const HeaderTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: clamp(1rem, 1.4vw, 1.25rem);
  font-weight: 700;
  margin: 0;
  color: #303030;
`

export const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: #f4f4f4;
  cursor: pointer;
  &:hover {
    background: #eaeaea;
  }
`

export const ScrollBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
`

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
  margin-top: 8px;
`

export const ProductDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ProductFieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 0;
`
